function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Live-Badge"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,0 L30,0 L30,0 L30,35 C30,43.2842712 23.2842712,50 15,50 C6.71572875,50 1.01453063e-15,43.2842712 0,35 L0,15 C-1.01453063e-15,6.71572875 6.71572875,1.52179594e-15 15,0 Z",
  id: "Rectangle",
  fill: "#5C7284"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 4,
  y: 4,
  width: 22,
  height: 42,
  rx: 11
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#6DD400",
  fill: "#4AA546",
  cx: 15,
  cy: 35,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-7",
  stroke: "#F7B500",
  strokeWidth: 1.4,
  fill: "#F7B500",
  cx: 15,
  cy: 24,
  r: 3.3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-8",
  stroke: "#E02020",
  strokeWidth: 1.4,
  fill: "#E02020",
  cx: 15,
  cy: 14,
  r: 3.3
})));

function SvgLiveBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "50px",
    viewBox: "0 0 30 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveBadge);
export default __webpack_public_path__ + "static/media/live-badge.2b9d2be4.svg";
export { ForwardRef as ReactComponent };